import { render, staticRenderFns } from "./TabNotificationSetting.vue?vue&type=template&id=1fe980ae"
import script from "./TabNotificationSetting.vue?vue&type=script&lang=js"
export * from "./TabNotificationSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports